function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import find from 'ramda/src/find';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import { stateGo } from 'redux-ui-router';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import DateRangeShortcutHelper from 'invision-core/src/components/helpers/daterange.shortcut.helper';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import i18n from 'invision-core/src/components/i18n/i18n';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { ALLOW_CREDIT_DEBIT_NOTE, ONE_TIME_MAKE_PAYMENT, PAYMENT_ADJUSTMENT_ACCESS, VIEW_FUTURE_INVOICES_ACCESS } from '../../../security.attributes';
import { ACCOUNT_SUMMARY_ITEM_LEVEL_MENU_OPTIONS, ADJUSTMENT_CONFIG_ENABLED, ADJUSTMENTS, APPLY_TAX_CERTIFICATE_ID, BILLING_PAYMENTS_SEARCH_PLACEHOLDER, billingLedgerTabList, CREATE_NOTE_ID, CREDIT_NOTES, DEBIT_NOTES, DEPOSITS, ENABLE_CREATE_NOTE, FUTURE_INVOICE_URL, INVOICES, MISC_ADJUSTMENT_ID, MISC, OVERALL, PAYMENTS } from '../billing.payments.constants';
import { CanUserPerformMiscellaneousAndItemAdjustmentSelector, CurrentCustomerAccountingMethodSelector, CurrentCustomerConvergentBillerIdSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerSelector } from '../../../reducers/selectors/customer.selectors';
import { ConvergentBillerSubscriberSummaryPostPaidAccountSelector, IsARCSubscriptionMgmtFeatureToggleSelector, IsCurrentAccountPostpaidSelector } from '../../../reducers/selectors/customer.convergent.biller.selectors';
import { AdjustmentConfigSelector, BillingLedgerCurrentTabSelector, BillingLedgerTableDataSelector, DateShortcutSelector, EndDateSelector, InvoiceFilterSelector, InvoiceListForDropDownSelector, IsFetchingBillingPaymentsSelector, PageCountOfLedgerSelector, PageNumberSelector, PageSizeOfLedgerSelector, RecordCountOfLedgerSelector, StartDateSelector, TypeSelector } from '../../../reducers/selectors/customer.billing.selectors';
import { InvEnablePaymentTransferSelector } from '../../../reducers/selectors/customer.actions.template.selectors';
import { retrieveLedgerSummary, setCurrentTabBillingLedger, setPageSizePreference, updateDateRange, updateInvoiceFilter, updatePageNumber, updateTypeFilter } from '../../../reducers/actions/customer.billing.actions';
import { fetchInvoices } from '../../../reducers/actions/customer.cases.actions';
import LocaleKeys from '../../../locales/keys';
import MakePaymentConstants from '../../customer/makePayment/make.payment.constants';
import { MISC_ADJUSTMENT } from '../../adjustment/adjustment.modal.constants';
import { retrieveConvergentBillerSubscriberSummary } from '../../../reducers/actions/customer.convergent.biller.actions';
import { CurrentCustomerNodeSelector } from '../../../reducers/selectors/customer.account.hierarchy.selectors';
import { ACCOUNTING_METHODS } from '../../createCustomer/billingInformationSection/billing.information.section.constants';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../shared/constants/customer.constants';
import { REPORTING_LEVELS } from '../../../components/customer/accountHierarchy/account.hierarchy.constants';
var ALL_PAYMENT_TYPES = OVERALL;
var BillingPaymentsController = /*#__PURE__*/function () {
  function BillingPaymentsController($ngRedux, $scope, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, BillingPaymentsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $scope: $scope,
      $timeout: $timeout,
      ACCOUNTING_METHODS: ACCOUNTING_METHODS,
      billingLedgerTabList: billingLedgerTabList(),
      cellTypes: {
        ADJUSTMENT: i18n.translate(LocaleKeys.ADJUSTMENT),
        CREDIT_NOTE: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.CREDIT_NOTE),
        DEBIT_NOTE: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.DEBIT_NOTE),
        INVOICE_SUMMARY: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_SUMMARY),
        REFUND: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.REFUND),
        PAYMENT: i18n.translate(LocaleKeys.PAYMENT),
        STATEMENT: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.STATEMENT),
        DEPOSITS: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DEPOSIT)
      },
      checkIfUserHasAccessToViewFutureInvoices: this.checkIfUserHasAccessToViewFutureInvoices.bind(this),
      CoreLocaleKeys: CoreLocaleKeys,
      filter: ALL_PAYMENT_TYPES,
      handleMoreMenuOptions: this.handleMoreMenuOptions.bind(this),
      localeKeys: LocaleKeys,
      isReceivablesModalOpen: false,
      isStatement: this.isStatement.bind(this),
      onReceivablesModalClose: this.onReceivablesModalClose.bind(this),
      onSearchCleared: this.onSearchCleared.bind(this),
      onQuickInfoModalClose: this.onQuickInfoModalClose.bind(this),
      pageSizeSelected: this.pageSizeSelected.bind(this),
      receivables: [],
      redirectToSelectedState: this.redirectToSelectedState.bind(this),
      searchInvoiceNumber: this.searchInvoiceNumber.bind(this),
      searchPlaceholder: BILLING_PAYMENTS_SEARCH_PLACEHOLDER(),
      selectedShortcut: null,
      selectTab: this.selectTab.bind(this),
      shortcuts: DateRangeShortcutHelper.getShortListShortcuts(),
      stateOrName: 'index.customercare.customer.billingpayments',
      tabs: [{
        active: true,
        name: i18n.translate(LocaleKeys.LEDGER)
      }],
      uiNotificationService: uiNotificationService,
      updatePageNumber: this.updatePageNumber.bind(this)
    });
    this.setOptions();
    this.BILLING_AND_PAYMENTS = i18n.translate(LocaleKeys.BILLING_AND_PAYMENTS);
    this.LOADING = i18n.translate(LocaleKeys.LOADING);
    this.MISC_ADJUSTMENT = i18n.translate(LocaleKeys.MISC_ADJUSTMENT);
    this.TYPE = i18n.translate(LocaleKeys.TYPE);
    this.VIEW_DETAILS = i18n.translate(LocaleKeys.VIEW_DETAILS);
    this.ADJUSTMENT_TYPE = MISC;
    this.BILLING_PAYMENTS_TYPE = MakePaymentConstants.MAKE_PAYMENT_TYPES.BILLING_PAYMENTS;
    this.navigateToView = function (dgRowEntity) {
      _this.actions.stateGo(dgRowEntity.sref, {
        invoiceId: dgRowEntity.invoiceId
      }, {
        location: true,
        notify: true
      });
    };
    this.navigateToCreditNoteDetails = function (rowEntity) {
      _this.actions.stateGo(rowEntity.sref, {
        creditNoteId: rowEntity.type === _this.cellTypes.CREDIT_NOTE ? rowEntity.creditNoteId : rowEntity.type === _this.cellTypes.DEBIT_NOTE ? rowEntity.debitNoteId : rowEntity.adjustmentId
      }, {
        location: true,
        notify: true
      });
    };
    $scope.datatable = {
      listComponentScope: this,
      adjustmentType: this.ADJUSTMENT_TYPE,
      cellTypes: this.cellTypes,
      creditNoteWithTaxCertificateTooltipTemplate: require('../cellTemplates/creditnote.tax.certificate.tooltip.template.html'),
      getAccountBalanceColumnHeader: this.getAccountBalanceColumnHeader,
      handleItemsMoreOptionsMenuSelected: this.handleItemsMoreOptionsMenuSelected,
      invoiceIdTooltipLabel: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_NUMBER),
      invoiceDisputeTooltip: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.INVOICE_HAS_DISPUTE),
      partialAdjustmentTooltip: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PARTIAL_ADJUSTMENT_TOOLTIP),
      partialPaymentTooltip: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PARTIAL_PAYMENT_TOOLTIP),
      paymentIdTooltipLabel: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PAYMENT_ID),
      onRowEntitySelected: this.navigateToView,
      openCreditDebitNoteDetails: this.navigateToCreditNoteDetails,
      openQuickInfoModal: this.openQuickInfoModal.bind(this),
      reasonCodeTooltipLabel: i18n.translate(LocaleKeys.REASON_CODE),
      remainingBalanceTooltipTemplate: require('../cellTemplates/remaining.balance.tooltip.template.html'),
      remainingBalanceTooltipLabel: i18n.translate(LocaleKeys.REMAINING_BALANCE),
      singleLabelValueTooltipTemplate: require('../cellTemplates/single.label.value.tooltip.template.html'),
      tabList: this.billingLedgerTabList,
      transactionIdTooltipLabel: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.TRANSACTION_ID),
      viewDetails: this.VIEW_DETAILS,
      whtCertDateTooltipLabel: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.WITHHELD_TAX_CERTIFICATE_DATE),
      whtCertIdTooltipLabel: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.WITHHELD_TAX_CERTIFICATE_ID)
    };
    this.adjustmentModalConfig = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.adjustmentModalApi = api;
      }
    };
    this.applyCreditNoteModalConfig = {
      onRegisterApi: function onRegisterApi(_ref2) {
        var api = _ref2.api;
        _this.applyCreditNoteModalApi = api;
      }
    };
    this.applyTaxCertificateModalConfig = {
      onRegisterApi: function onRegisterApi(_ref3) {
        var api = _ref3.api;
        _this.applyTaxCertificateModalApi = api;
      }
    };
  }
  return _createClass(BillingPaymentsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          adjustmentConfig: AdjustmentConfigSelector(store),
          adjustmentReasonCodes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AdjustmentReason, store),
          adjustmentTypeCodes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AdjustmentType, store),
          billingLedgerCurrentTab: BillingLedgerCurrentTabSelector(store),
          billingLedgerTableData: BillingLedgerTableDataSelector(store),
          canUserPerformMiscellaneousAndItemAdjustment: CanUserPerformMiscellaneousAndItemAdjustmentSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          currentCustomerNode: CurrentCustomerNodeSelector(store),
          customerConvergentBillerId: CurrentCustomerConvergentBillerIdSelector(store),
          dateShortcut: DateShortcutSelector(store),
          endDate: EndDateSelector(store),
          invoiceFilter: InvoiceFilterSelector(store),
          invoiceListForFilter: InvoiceListForDropDownSelector(store),
          isARCSubscriptionMgmtFeatureLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.MicroserviceConfiguration, store),
          isARCSubscriptionMgmtFeatureToggle: IsARCSubscriptionMgmtFeatureToggleSelector(store),
          isAdjustmentConfigLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AdjustmentConfig, store),
          isCurrentAccountPostpaid: IsCurrentAccountPostpaidSelector(store),
          isDbss: IsDbss(store),
          isFetchingBillingPayments: IsFetchingBillingPaymentsSelector(store),
          isPaymentTransferEnabled: InvEnablePaymentTransferSelector(store),
          isPosPaymentTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PointOfSalePaymentType, store),
          pageCountOfLedger: PageCountOfLedgerSelector(store),
          pageNumber: PageNumberSelector(store),
          pageSizeOfLedger: PageSizeOfLedgerSelector(store),
          paymentInstrumentTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PaymentInstrumentType, store),
          paymentInstrumentTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PaymentInstrumentType, store),
          postPaidAccount: ConvergentBillerSubscriberSummaryPostPaidAccountSelector(store),
          recordCountOfLedger: RecordCountOfLedgerSelector(store),
          startDate: StartDateSelector(store),
          typeFilter: TypeSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        fetchInvoices: fetchInvoices,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveLedgerSummary: retrieveLedgerSummary,
        setCurrentTabBillingLedger: setCurrentTabBillingLedger,
        setPageSizePreference: setPageSizePreference,
        stateGo: stateGo,
        updateDateRange: updateDateRange,
        updateInvoiceFilter: updateInvoiceFilter,
        updatePageNumber: updatePageNumber,
        updateTypeFilter: updateTypeFilter
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (!this.state.isAdjustmentConfigLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentConfig);
      }
      if (!this.state.adjustmentReasonCodes || this.state.adjustmentReasonCodes.length < 1) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentReason);
      }
      if (!this.state.adjustmentTypeCodes || this.state.adjustmentTypeCodes.length < 1) {
        this.actions.fetchCodeType(MetadataConstants.codes.AdjustmentType);
      }
      if (!this.state.isARCSubscriptionMgmtFeatureLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.MicroserviceConfiguration);
      }
      if (!this.state.paymentInstrumentTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentType);
      }
      if (this.state.customerConvergentBillerId) {
        this.actions.fetchInvoices(this.state.currentCustomerId);
      }
      if (!this.state.isPosPaymentTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PointOfSalePaymentType);
      }
      if (!pathOr(0, ['length'], this.state.postPaidAccount)) {
        this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId);
      }
      this.initDateRange();
      this.retrieveConvergentBiller();
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      this.checkIfUserHasAccessToViewFutureInvoices();
      this.hasCreateNoteAccess();
      this.createNoteModalConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.createNoteModalApi = api;
        }
      };
      this.moreMenuOptions = [{
        title: i18n.translate(this.localeKeys.MISC_ADJUSTMENT),
        id: 0
      }, {
        title: i18n.translate(this.localeKeys.CREDIT_DEBIT_NOTE.CREATE_NOTE),
        id: 1
      }];
      if (this.state.isDbss) {
        this.moreMenuOptions.push({
          title: i18n.translate(this.localeKeys.APPLY_TAX_CERTIFICATE.APPLY_TAX_CERTIFICATE),
          id: 2
        });
      }
      ;
      if (this.ACCOUNTING_METHODS[1].value === this.state.currentCustomerAccountingMethod) {
        delete this.billingLedgerTabList.OPEN_INVOICES;
        this.selectTab(this.billingLedgerTabList.ACCOUNT_SUMMARY);
      } else if (this.state.billingLedgerCurrentTab && this.billingLedgerTabList[this.state.billingLedgerCurrentTab.key]) {
        this.selectTab(this.billingLedgerTabList[this.state.billingLedgerCurrentTab.key]);
      } else {
        this.selectTab(this.billingLedgerTabList.OPEN_INVOICES);
      }
    }
  }, {
    key: "onOptionSelected",
    value: function onOptionSelected(item) {
      this.typeOptions.forEach(function (item) {
        item.selected = false;
      });
      item.selected = true;
      switch (item.text) {
        case i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.ADJUSTMENTS):
          this.filter = ADJUSTMENTS;
          break;
        case i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.CREDIT_NOTES):
          this.filter = CREDIT_NOTES;
          break;
        case i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.DEBIT_NOTES):
          this.filter = DEBIT_NOTES;
          break;
        case i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.INVOICES):
          this.filter = INVOICES;
          break;
        case i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.PAYMENTS):
          this.filter = PAYMENTS;
          break;
        default:
          this.filter = ALL_PAYMENT_TYPES;
          break;
      }
      this.actions.updateTypeFilter(this.filter);
      this.retrieveConvergentBiller();
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var _ref5 = this.state || {},
        _ref5$typeFilter = _ref5.typeFilter,
        typeFilter = _ref5$typeFilter === void 0 ? ALL_PAYMENT_TYPES : _ref5$typeFilter;
      this.typeOptions = [{
        selected: typeFilter === ALL_PAYMENT_TYPES,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.ALL)
      }, {
        selected: typeFilter === ADJUSTMENTS,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.ADJUSTMENTS)
      }, {
        selected: typeFilter === CREDIT_NOTES,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.CREDIT_NOTES)
      }, {
        selected: typeFilter === DEBIT_NOTES,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.DEBIT_NOTES)
      }, {
        selected: typeFilter === INVOICES,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.INVOICES)
      }, {
        selected: typeFilter === PAYMENTS,
        text: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_TYPES.PAYMENTS)
      }];
    }
  }, {
    key: "initDateRange",
    value: function initDateRange() {
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
      this.shortcuts = [entireHistoryDateShortcut].concat(_toConsumableArray(DateRangeShortcutHelper.getShortListShortcuts()));
      this.selectedShortcut = find(propEq(this.state.dateShortcut, 'urlId'), this.shortcuts);
      if (this.selectedShortcut) {
        this.actions.updateDateRange(this.selectedShortcut.start, this.selectedShortcut.end, this.selectedShortcut.urlId);
      } else {
        this.selectedShortcut = entireHistoryDateShortcut;
      }
    }
  }, {
    key: "updateRangeEndForShortcuts",
    value: function updateRangeEndForShortcuts() {
      if (this.state.dateShortcut) {
        this.initDateRange();
      }
    }
  }, {
    key: "handleItemsMoreOptionsMenuSelected",
    value: function handleItemsMoreOptionsMenuSelected(rowEntity, _ref6) {
      var item = _ref6.item;
      switch (item.id) {
        case ACCOUNT_SUMMARY_ITEM_LEVEL_MENU_OPTIONS.APPLY_CREDIT_NOTE:
          this.creditNoteData = rowEntity;
          this.openApplyCreditNoteModal();
          break;
        case ACCOUNT_SUMMARY_ITEM_LEVEL_MENU_OPTIONS.VIEW_TRANSACTION_DETAILS:
          this.actions.stateGo('index.customercare.customer.transactions.details', {
            transactionId: rowEntity.transactionId || rowEntity.paymentTransactionId
          }, {
            location: true,
            notify: true
          });
          break;
        case ACCOUNT_SUMMARY_ITEM_LEVEL_MENU_OPTIONS.VIEW_RECEIVABLES:
          this.openReceivablesModal(rowEntity.receivables, rowEntity.currencyCode);
          break;
        default:
          break;
      }
    }
  }, {
    key: "openReceivablesModal",
    value: function openReceivablesModal(receivables, currency) {
      this.receivables = receivables;
      this.invoiceCurrency = currency;
      this.isReceivablesModalOpen = true;
    }
  }, {
    key: "onReceivablesModalClose",
    value: function onReceivablesModalClose() {
      this.isReceivablesModalOpen = false;
    }
  }, {
    key: "getAccountBalanceColumnHeader",
    value: function getAccountBalanceColumnHeader() {
      return this.tabList.DEPOSITS.active ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DEPOSIT_BALANCE) : i18n.translate(LocaleKeys.CUSTOMER_DASHBOARD.ACCOUNT_BALANCE);
    }
  }, {
    key: "retrieveConvergentBiller",
    value: function retrieveConvergentBiller() {
      var _this3 = this;
      if (this.state.customerConvergentBillerId) {
        var request = this.buildBillingAndPaymentsRequest();
        request.request.PageSize = this.state.pageSizeOfLedger;
        request.request.PageNumber = this.state.pageNumber;
        this.actions.retrieveLedgerSummary(request).then(function () {
          _this3.setOptions();
        }).catch(function (error) {
          _this3.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged(startDate, endDate, selectedShortcut) {
      this.actions.updateDateRange(startDate, endDate, selectedShortcut && selectedShortcut.urlId ? selectedShortcut.urlId : null);
      this.selectedShortcut = find(propEq(this.state.dateShortcut, 'urlId'), this.shortcuts);
      this.retrieveConvergentBiller();
    }
  }, {
    key: "buildBillingAndPaymentsRequest",
    value: function buildBillingAndPaymentsRequest() {
      var request = {
        EndDate: this.state.endDate || undefined,
        Filter: this.billingLedgerTabList.DEPOSITS.active ? DEPOSITS : this.state.typeFilter,
        StartDate: this.state.startDate || undefined
      };
      request.InvoiceNumber = this.state.invoiceFilter || undefined;
      return {
        customerId: this.state.currentCustomerId,
        request: request
      };
    }
  }, {
    key: "onPaymentSuccess",
    value: function onPaymentSuccess() {
      this.updateRangeEndForShortcuts();
      this.retrieveConvergentBiller();
    }
  }, {
    key: "openAdjustmentModal",
    value: function openAdjustmentModal() {
      var _this4 = this;
      this.adjustmentType = MISC_ADJUSTMENT;
      this.showAdjustmentModal = true;
      this.$timeout(function () {
        _this4.adjustmentModalApi.open();
      });
    }
  }, {
    key: "onAdjustmentClose",
    value: function onAdjustmentClose() {
      this.updateRangeEndForShortcuts();
      this.retrieveConvergentBiller();
      this.adjustmentModalApi.close();
      this.showAdjustmentModal = false;
    }
  }, {
    key: "hasMakePaymentAccess",
    value: function hasMakePaymentAccess() {
      var _this$state$currentCu;
      return (this.state.isCurrentAccountPostpaid || this.state.isARCSubscriptionMgmtFeatureToggle) && !this.state.currentCustomerIsExternallyManagedAR && hasAccess(this.state.userSecurityAttributes, ONE_TIME_MAKE_PAYMENT) && ((_this$state$currentCu = this.state.currentCustomer) === null || _this$state$currentCu === void 0 ? void 0 : _this$state$currentCu.HierarchyReportingLevel) !== REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT;
    }
  }, {
    key: "hasMiscAdjustmentAccess",
    value: function hasMiscAdjustmentAccess() {
      return this.state.canUserPerformMiscellaneousAndItemAdjustment && this.state.postPaidAccount.length && this.state.postPaidAccount[0].AccountNumber && (!this.state.currentCustomerIsExternallyManagedAR || this.state.currentCustomerIsExternallyManagedAR) && hasAccess(this.state.userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS);
    }
  }, {
    key: "hasCreateNoteAccess",
    value: function hasCreateNoteAccess() {
      return this.state.adjustmentConfig[ENABLE_CREATE_NOTE] === ADJUSTMENT_CONFIG_ENABLED && hasAccess(this.state.userSecurityAttributes, ALLOW_CREDIT_DEBIT_NOTE);
    }
  }, {
    key: "showMoreMenu",
    value: function showMoreMenu() {
      return this.hasMiscAdjustmentAccess() && this.hasCreateNoteAccess();
    }
  }, {
    key: "isBalanceForwardAccountingMethod",
    value: function isBalanceForwardAccountingMethod() {
      return this.state.currentCustomerAccountingMethod === ACCOUNTING_METHODS[1].value;
    }
  }, {
    key: "redirectToSelectedState",
    value: function redirectToSelectedState() {
      this.actions.stateGo(FUTURE_INVOICE_URL);
    }
  }, {
    key: "isStatement",
    value: function isStatement() {
      var _this$state$currentCu2;
      return ((_this$state$currentCu2 = this.state.currentCustomer) === null || _this$state$currentCu2 === void 0 ? void 0 : _this$state$currentCu2.HierarchyReportingLevel) === REPORTING_LEVELS.REPORTING_LEVEL_STATEMENT;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "checkIfUserHasAccessToViewFutureInvoices",
    value: function checkIfUserHasAccessToViewFutureInvoices() {
      if (this.state.currentCustomer.HierarchyId) {
        this.isBillCycleChangeAllowed = !(this.state.currentCustomer && this.state.currentCustomer.HierarchyParentSubscriberId);
        this.hasFutureSatetmentsViewAccess = hasAccess(this.state.userSecurityAttributes, VIEW_FUTURE_INVOICES_ACCESS) && !this.state.currentCustomer.HierarchyParentSubscriberId;
      } else {
        this.hasFutureSatetmentsViewAccess = hasAccess(this.state.userSecurityAttributes, VIEW_FUTURE_INVOICES_ACCESS);
      }
    }
  }, {
    key: "searchInvoiceNumber",
    value: function searchInvoiceNumber(invoiceNumber) {
      if (invoiceNumber) {
        this.actions.updateInvoiceFilter(invoiceNumber.trim());
        this.retrieveConvergentBiller();
      }
    }
  }, {
    key: "handleMoreMenuOptions",
    value: function handleMoreMenuOptions(option) {
      if (option.item.id === MISC_ADJUSTMENT_ID) {
        this.openAdjustmentModal();
      }
      if (option.item.id === CREATE_NOTE_ID) {
        this.openCreateNoteModal();
      }
      if (option.item.id === APPLY_TAX_CERTIFICATE_ID) {
        this.openApplyTaxCertificateModal();
      }
    }
  }, {
    key: "openCreateNoteModal",
    value: function openCreateNoteModal() {
      var _this5 = this;
      this.showCreateNoteModal = true;
      this.$timeout(function () {
        _this5.createNoteModalApi.open();
      });
    }
  }, {
    key: "closeCreateNoteModal",
    value: function closeCreateNoteModal() {
      this.retrieveConvergentBiller();
      this.createNoteModalApi.close();
      this.showCreateNoteModal = false;
    }
  }, {
    key: "selectTab",
    value: function selectTab(selectedTab) {
      this.selectedTab = selectedTab;
      for (var tab in this.billingLedgerTabList) {
        this.billingLedgerTabList[tab].active = tab === selectedTab.key;
      }
      if (this.billingLedgerTabList.ACCOUNT_SUMMARY.active) {
        this.resetFilters();
        this.retrieveConvergentBiller();
      }
      if (this.billingLedgerTabList.DEPOSITS.active) {
        this.resetFilters();
        this.retrieveConvergentBiller();
      }
      this.actions.setCurrentTabBillingLedger(selectedTab);
      return this.billingLedgerTabList;
    }
  }, {
    key: "pageSizeSelected",
    value: function pageSizeSelected(pageSize) {
      this.actions.updatePageNumber(DEFAULT_PAGE_NUMBER);
      this.actions.setPageSizePreference(pageSize);
      this.retrieveConvergentBiller();
    }
  }, {
    key: "onSearchCleared",
    value: function onSearchCleared() {
      this.actions.updateInvoiceFilter(null);
      this.retrieveConvergentBiller();
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.actions.updateTypeFilter(ALL_PAYMENT_TYPES);
      this.actions.updateInvoiceFilter(null);
      this.actions.updatePageNumber(DEFAULT_PAGE_NUMBER);
      this.actions.setPageSizePreference(DEFAULT_PAGE_SIZE);
      this.actions.updateDateRange(null, null, null);
      this.selectedShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
    }
  }, {
    key: "openQuickInfoModal",
    value: function openQuickInfoModal(entity) {
      this.quickInfoData = entity;
      this.showQuickInfoModal = true;
    }
  }, {
    key: "onQuickInfoModalClose",
    value: function onQuickInfoModalClose() {
      this.showQuickInfoModal = false;
    }
  }, {
    key: "openApplyCreditNoteModal",
    value: function openApplyCreditNoteModal() {
      var _this6 = this;
      this.showApplyCreditNoteModal = true;
      this.$timeout(function () {
        _this6.applyCreditNoteModalApi.open();
      });
    }
  }, {
    key: "onApplyCreditNoteModalClose",
    value: function onApplyCreditNoteModalClose() {
      this.retrieveConvergentBiller();
      this.applyCreditNoteModalApi.close();
      this.showApplyCreditNoteModal = false;
    }
  }, {
    key: "openApplyTaxCertificateModal",
    value: function openApplyTaxCertificateModal() {
      var _this7 = this;
      this.showApplyTaxCertificateModal = true;
      this.$timeout(function () {
        _this7.applyTaxCertificateModalApi.open();
      });
    }
  }, {
    key: "onApplyTaxCertificateModalClose",
    value: function onApplyTaxCertificateModalClose() {
      this.retrieveConvergentBiller();
      this.applyTaxCertificateModalApi.close();
      this.showApplyTaxCertificateModal = false;
    }
  }, {
    key: "updatePageNumber",
    value: function updatePageNumber(pageNumber) {
      this.actions.updatePageNumber(pageNumber);
      this.retrieveConvergentBiller();
    }
  }]);
}();
export default {
  controller: BillingPaymentsController,
  controllerAs: 'billingPaymentsList',
  template: require('./billing.payments.list.page.html')
};